import { store } from '../store/configureStore'
import {
    setNodes as setNodesRedux,
    postNode as postNodeRedux,
    patchNode as patchNodeRedux,
    toggleNode as toggleNodeRedux,
    setParent as setParentRedux,
    setNextSibling as setNextSiblingRedux,
    setPreviousSibling as setPreviousSiblingRedux,
    selectNodeById as selectNodeByIdRedux,
    selectParentId as selectParentIdRedux,
    selectRootNodeChildren as selectRootNodeChildrenRedux,
    selectBestChildIdFor as selectBestChildIdForRedux
} from '../store/node'

const { dispatch, getState } = store

export const initTreeEngine = () => {
    console.log(getState().nodes)
}

export const setNodes = (nodes) => {
    dispatch(setNodesRedux(nodes))
}

export const postNode = (body) => {
    dispatch(postNodeRedux(body))
}

export const patchNode = (nodeId, body) => {
    dispatch(patchNodeRedux(nodeId, body))
}

export const toggleNode = (nodeId) => {
    dispatch(toggleNodeRedux(nodeId))
}

export const setParent = (id, parentId) => {
    dispatch(setParentRedux(id, parentId))
}

export const setPreviousSibling = (id, previousSiblingId) => {
    dispatch(setPreviousSiblingRedux(id, previousSiblingId))
}

export const setNextSibling = (id, nextSiblingId) => {
    dispatch(setNextSiblingRedux(id, nextSiblingId))
}

export const selectNodeById = (nodeId) => {
    return selectNodeByIdRedux(nodeId)(getState())
}

export const selectParentId = (nodeId) => {
    return selectParentIdRedux(nodeId)(getState())
}

export const selectRootNodeChildren = () => {
    return selectRootNodeChildrenRedux()(getState())
}

export const selectBestChildIdFor = (nodeId) => {
    return selectBestChildIdForRedux(nodeId)(getState())
}
